prismanoteApp.filter('escape', function () {
  return window.encodeURIComponent
})
